// Re-export generated arg/response type aliases
export type { SwitchTenantArg, SwitchTenantResponse } from './types.generated';

export enum AuthApiActionTypes {
  SetAccessToken = 'auth/setAccessToken',
  ClearAccessToken = 'auth/clearAccessToken',
  RefreshTokenFailed = 'auth/refreshTokenFailed',
  Logout = 'auth/logout',
}

export interface JwtPayload extends Record<string, unknown> {
  sub: string;
  iss: string;
  isMfaEnabled: boolean;
  isMfaAuthenticated: boolean;
  isEmailConfirmed: boolean;
  iat: string;
  exp: string;
  // extra claims
  roles?: string[];
  status?: number;
  tenant?: {
    id: number;
    name: string;
    slug: string;
    isSystem: boolean;
  };
  permissions?: string[];
}

export interface AuthTokenState {
  accessToken?: string;
  /** True when the user has explicitly logged out. Prevents token refresh attempts during the signout flow. */
  isLoggedOut?: boolean;
}

/**
 * Store interface for authToken slice
 */
export interface AuthTokenStore {
  authToken: AuthTokenState;
}

export interface AuthApiError {
  details?: {
    statusCode: number;
    message: string;
    error: string;
  };
  status?: number | string;
  message?: string;
}
